import { createContext, useContext } from 'react'

export const EMPTY_ROUTING_OPTION_IDS: ReadonlySet<string> = new Set()

/** Option ids of the selected question that are referenced by branching or skip rules. */
export const RoutingOptionIdsContext = createContext<ReadonlySet<string>>(EMPTY_ROUTING_OPTION_IDS)

export function useRoutingOptionIds(): ReadonlySet<string> {
  return useContext(RoutingOptionIdsContext)
}
